import React, { Component } from 'react';
import equal from 'fast-deep-equal';
import axios from 'axios';
import Toggle from 'react-toggle';

export default class SendPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: `SendPage`,
      active: false,
      name: '',
      mail: '',
      company: '',
      nieuws: true,
    };

    this.sendButton = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props, prevProps)) {
      // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
      if (this.props.currentActive === this.state.index) this.setState({ active: true });
      else this.setState({ active: false });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  handleChange(event, checkbox = false) {
    if (checkbox) {
      this.setState({ nieuws: event.target.checked });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  }

  async startDownload(url, graph, form) {
    console.log(JSON.stringify(form));

    const data = {
      graph: graph,
      formInput: JSON.stringify(form),
    };

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async handleDownload() {
    const { name, mail, company, nieuws } = this.state;
    const button = this.sendButton.current;

    if ((!name, !mail)) {
      button.value = 'Please fill in the required fields';

      setTimeout(() => {
        button.value = 'Receive my carbon footprint';
      }, 1000);
      return;
    }

    let hostNode = this.props.hostNode.hostNode;

    const form = this.props.forwardRef.current;
    const formData = {};
    const fields = form.querySelectorAll('input');
    const regex = /[\ ]/gm;

    [].forEach.call(fields, (field, key) => {
      const name = field.name.replace(regex, '_');
      formData[name] = field.value;
    });

    let bomen = hostNode.querySelector('#totalPage-result-boom').innerText;
    let watt = hostNode.querySelector('#totalPage-result-watt').innerText;
    // let cost = hostNode.querySelector('#totalPage-result-cost').innerText;

    formData['visualBoom'] = bomen;
    formData['visualWatt'] = watt;
    // formData['visualCost'] = cost;

    const graph = hostNode.querySelector('canvas');
    const graphData = graph.toDataURL();

    /* this.startDownload("/wp-content/plugins/co2-calculator/frontend/includes/co2Chart/setData.php", graphData, formData)
        .then(data => {
            console.log(data);
            
            let iframe = document.createElement("iframe");
            iframe.setAttribute("src", '/wp-content/plugins/co2-calculator/frontend/includes/co2Chart/output.php');
            iframe.setAttribute("style", "display: none");
            document.body.appendChild(iframe);
        }) */

    const sendingObject = {
      data: {
        co2PdfData: graphData,
        formInput: formData,
        personalData: {
          name: this.state.name,
          mail: this.state.mail,
          company: this.state.company,
          // nieuwsbrief: this.state.nieuws,
        },
      },
    };

    //console.log(sendingObject);

    button.value = 'Sending...';

    const sendingString = JSON.stringify(sendingObject);

    axios
      .post(
        '/wp-content/plugins/co2-calculator/frontend/includes/co2Chart/setData.php',
        sendingString,
      )
      .then(function (response) {
        //console.log(response.data);
        //let iframe = document.createElement("iframe");
        //iframe.setAttribute("src", '/wp-content/plugins/co2-calculator/frontend/includes/co2Chart/output.php');
        //iframe.setAttribute("style", "display: none");
        //document.body.appendChild(iframe);

        console.log(response.data);

        if (response.data != true) {
          button.value = 'Something went wrong';
        } else {
          button.value = 'Sent carbon footprint';
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div className='co2calculator__section sendPage' isactive={this.state.active.toString()}>
        <h3 className='center'>My carbon footprint</h3>
        <form className='totalPage__fields--send'>
          <label className='totalPage__label isRequied'>
            Name
            <input
              required
              className='totalPage__field sendPage__field'
              onChange={(e) => {
                this.handleChange(e);
              }}
              type='text'
              name='name'
              value={this.state.name}
            />
          </label>
          <label className='totalPage__label isRequied'>
            Email address
            <input
              required
              className='totalPage__field sendPage__field'
              onChange={(e) => {
                this.handleChange(e);
              }}
              type='text'
              name='mail'
              value={this.state.mail}
            />
          </label>
          <label className='totalPage__label'>
            Company name
            <input
              className='totalPage__field sendPage__field'
              onChange={(e) => {
                this.handleChange(e);
              }}
              type='text'
              name='company'
              value={this.state.company}
            />
          </label>
          {/* <label className='totalPage__label newsletter'>
            Receive newsletter?
            <Toggle
              name='nieuws'
              icons={false}
              defaultChecked={this.state.nieuws}
              onChange={(e) => {
                this.handleChange(e, true);
              }}
            />
          </label> */}
          <input
            ref={this.sendButton}
            className='co2calculator__nextButton'
            onClick={(event) => {
              this.handleDownload();
              this.handleSubmit(event);
            }}
            type='submit'
            value='Receive my carbon footprint'
          />
        </form>

        <div className='StartVerkleinen'>
          <h3>Start reducing your carbon footprint now</h3>
          <button
            className='co2calculator__nextButton'
            type='button'
            onClick={() => window.open('/#cfm-roadmap', '_blank')}
          >
            Use our carbon footprint roadmap
          </button>
        </div>
      </div>
    );
  }
}
